module.exports = __webpack_public_path__ + "img/letter_960.5d3641d8.png";